'use client'

import { useState, useEffect } from 'react'

import cn from 'clsx'

import { Button, Copy, ProjectTile, Loading } from 'shared-components'

import FeatureProject from './FeatureProject'
import ProjectCategories from './ProjectCategories'

import s from './ProjectGrid.module.sass'

function ProjectGrid({
    title,
    copy,
    projects: _projects,
    totalProjects,
    featureProject,
    projectCategories,
    showMore,
    getProjectsByProjectCategory,
}: any) {
    const [projects, setProjects] = useState(_projects)
    const [isLoading, setIsLoading] = useState(true)
    const [isLoadingMore, setIsLoadingMore] = useState(false)
    const [selectedProjectCategory, setSelectedProjectCategory] = useState('')

    const handleClick = () => {
        setIsLoadingMore(true)
        setProjects(null)
        showMore(projects?.length)
        setProjects(_projects)
        setTimeout(() => {
            setIsLoadingMore(false)
        }, 500)
    }

    const handleProjectCategoryClick = (projectCategory: string) => {
        setIsLoading(true)
        setProjects(null)
        setSelectedProjectCategory(projectCategory)
        getProjectsByProjectCategory(projectCategory)
        setProjects(_projects)
        setTimeout(() => {
            setIsLoading(false)
        }, 500)
    }

    useEffect(() => {
        if (_projects?.length > 0) {
            setIsLoading(false)
        }
    }, [_projects])

    const _title = selectedProjectCategory
        ? projectCategories?.find((cat: any) => cat.slug === selectedProjectCategory)?.title
        : title
    const _copy = selectedProjectCategory
        ? projectCategories?.find((cat: any) => cat.slug === selectedProjectCategory)?.copy
        : copy

    return (
        <section className={s.ProjectGrid}>
            {featureProject && <FeatureProject project={featureProject} />}
            <div className={cn(s.Cont, 'container')}>
                <ProjectCategories
                    projectCategories={projectCategories}
                    selectedProjectCategory={selectedProjectCategory}
                    handleProjectCategoryClick={handleProjectCategoryClick}
                />
                <div className={s.Intro}>
                    {(_title || title) && <h3 dangerouslySetInnerHTML={{ __html: _title || title }} />}
                    {(_copy || copy) && (
                        <div className={s.Copy}>
                            <Copy copy={_copy || copy} />
                        </div>
                    )}
                </div>
                {isLoading ? (
                    <div className={s.Loading}>
                        <Loading />
                    </div>
                ) : _projects?.length === 0 && !isLoading ? (
                    <div className={s.NoProjects}>No projects found.</div>
                ) : (
                    <div className={s.Projects}>
                        {_projects?.map((project: any, index: number) => {
                            return <ProjectTile project={project} linkTarget="_blank" key={index} />
                        })}
                    </div>
                )}
                {_projects?.length < totalProjects && !selectedProjectCategory && !isLoading && (
                    <div className={s.ShowMore}>
                        <Button title="Show More" handleClick={handleClick} loading={isLoadingMore} />
                    </div>
                )}
            </div>
        </section>
    )
}

export default ProjectGrid
